import { useEffect } from 'react';
import { X } from 'lucide-react';
import { classNames } from '../../utils/classNames';

function Drawer({ open, onClose, title, description, children, footer, side = 'right' }) {
  useEffect(() => {
    if (!open) return undefined;
    const handleKeyDown = (event) => event.key === 'Escape' && onClose();
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);

  return (
    <div className={classNames('fixed inset-0 z-50 transition', open ? 'pointer-events-auto' : 'pointer-events-none')} aria-hidden={!open}>
      <button onClick={onClose} aria-label="Cerrar panel" className={classNames('absolute inset-0 bg-slate-950/45 transition-opacity', open ? 'opacity-100' : 'opacity-0')} />
      <aside
        role="dialog"
        aria-modal="true"
        aria-labelledby="drawer-title"
        className={classNames(
          'absolute inset-y-0 flex w-full max-w-md flex-col bg-white shadow-elevated transition-transform duration-300',
          side === 'right' ? 'right-0' : 'left-0',
          open ? 'translate-x-0' : side === 'right' ? 'translate-x-full' : '-translate-x-full'
        )}
      >
        <header className="flex items-start justify-between gap-4 border-b p-5">
          <div>
            <h2 id="drawer-title" className="font-semibold text-content-primary">{title}</h2>
            {description && <p className="mt-1 text-sm text-content-muted">{description}</p>}
          </div>
          <button onClick={onClose} className="rounded-md p-1.5 text-content-muted hover:bg-slate-100" aria-label="Cerrar">
            <X className="size-5" />
          </button>
        </header>
        <div className="flex-1 overflow-y-auto p-5">{children}</div>
        {footer && <footer className="flex justify-end gap-3 border-t bg-slate-50 p-5">{footer}</footer>}
      </aside>
    </div>
  );
}

export default Drawer;
